import { Injectable, signal } from '@angular/core';
import { AppSettings, defaults } from '../config';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private optionsSignal = signal<AppSettings>(this.loadInitialOptions());

  constructor() {}

  private loadInitialOptions(): AppSettings {
    const savedTheme = localStorage.getItem("bilgebot-theme");
    const initialOptions = { ...defaults };

    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
      initialOptions.theme = savedTheme;
    }

    return initialOptions;
  }

  getOptions() {
    return this.optionsSignal();
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => ({
      ...current,
      ...options,
    }));
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
